<script>
  import Breadcrumbs from "@/core/components/Breadcrumbs"
  import SeasonalitiesList from "@/domains/lines/views/seasonalities/partials/SeasonalitiesList"
  import Icon from "@/core/components/Icon"
  import FilterInput from "@/core/components/FilterInput.vue"

  export default {
    components: {
      Breadcrumbs,
      SeasonalitiesList,
      Icon,
      FilterInput,
    },
    data: () => {
      return {
        title: "Sazonalidades",
        crumbs: [
          { name: "Início", path: "index" },
          { name: "Linhas", path: "lines.index" },
          {
            name: "Sazonalidades",
            path: "lines.seasonalities",
          },
        ],
        filters: {
          desazonalidade: "",
          dtinicio: "",
          dtfim: "",
        },
      }
    },
    methods: {
      searchSeasonalities() {
        this.$refs.table.getSeasonalities(this.filters)
      },
      cleanFilters() {
        this.filters = {
          desazonalidade: "",
          dtinicio: "",
          dtfim: "",
        }
        this.$refs.table.getSeasonalities(this.filters)
      },
    },
  }
</script>

<template>
  <div class="w-full bg-gray-light">
    <div class="px-2 my-4 sm:px-6">
      <Breadcrumbs class="mb-2" :crumbs="crumbs"/>
      <div
        class="flex flex-wrap justify-between align-baseline border-b-2 border-green-base mb-2"
      >
        <h1 class="text-green-base uppercase pt-5">Sazonalidades</h1>
        <router-link
          tag="button"
          class="px-2 py-2 mb-2 form-new-green sm:py-1"
          :to="{ name: 'lines.seasonalities.create' }"
        >
          <div class="flex items-center justify-center">
            <Icon icon="plus" class="h-4 mr-1 fill-current"/>
            Nova Sazonalidade
          </div>
        </router-link>
      </div>
      <form class="p-2" @submit.prevent="searchSeasonalities">
        <h1 class="text-green-base mb-2">Filtre sua pesquisa</h1>
        <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-5 h-8">
          <div
            class="grid sm:col-span-5 md:col-span-5 lg:col-span-4 lg:grid-cols-4 lg:w-11/12 gap-4"
          >
            <FilterInput
              v-model="filters.desazonalidade"
              name="desazonalidade"
              type="text"
              input-classes=""
              placeholder="Nome"
              icon="icon_calendar.svg"
            />
            <FilterInput
              v-model="filters.dtinicio"
              name="desazonalidade"
              type="date"
              input-classes=""
              placeholder="Início"
              icon="icon_calendar.svg"
            />
            <FilterInput
              v-model="filters.dtfim"
              name="desazonalidade"
              type="date"
              input-classes=""
              placeholder="Fim"
              icon="icon_calendar.svg"
            />
          </div>
          <div
            class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 sm:w-full justify-end lg:mr-3 h-8"
          >
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-red text-xs uppercase"
              type="button"
              @click="cleanFilters"
            >
              Limpar
            </button>
            <button
              class="flex sm:col-span-1 md:col-span-1 lg:col-span-1 justify-center items-center form-submit lg:ml-1"
              type="submit"
            >
              Pesquisar
            </button>
          </div>
        </div>
      </form>
      <div class="p-2">
        <SeasonalitiesList ref="table"/>
      </div>
    </div>
  </div>
</template>
